import React from 'react';
import * as S from './styled';
export const Loader = ({ appearance = 'secondary', size = 'medium' }) => (React.createElement(S.Wrapper, { viewBox: "0 0 100 100", "$size": size, "aria-label": "loader", "data-testid": "Loader" },
    React.createElement(S.Circle, { cx: "50", cy: "50", r: "45", "$appearance": appearance })));
//# sourceMappingURL=Loader.js.map